/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */
import type {
  CreateIncomingPurchaseDocumentBody,
  CreateIncomingPurchaseDocumentPaymentBody,
  CustomCreateIncomingPurchaseDocument,
  Error,
  FileMetadata,
  GetIncomingPurchaseDocumentAttachments200,
  GetIncomingPurchaseDocumentPayments200,
  GetIncomingPurchaseDocuments200,
  GetIncomingPurchaseDocumentsParams,
  IncomingPurchaseDocument,
  Payment,
  UpdateIncomingPurchaseDocumentBody,
  UploadIncomingPurchaseDocumentAttachmentBody,
  ValidationError
} from '../model';

import { customFetch } from '../../mutator/custom-fetch';

/**
 * @summary Create incoming purchase document
 */
export type createIncomingPurchaseDocumentResponse201 = {
  data: IncomingPurchaseDocument
  status: 201
}

export type createIncomingPurchaseDocumentResponse400 = {
  data: Error
  status: 400
}

export type createIncomingPurchaseDocumentResponse401 = {
  data: Error
  status: 401
}

export type createIncomingPurchaseDocumentResponse403 = {
  data: Error
  status: 403
}

export type createIncomingPurchaseDocumentResponse404 = {
  data: Error
  status: 404
}

export type createIncomingPurchaseDocumentResponse422 = {
  data: ValidationError
  status: 422
}

export type createIncomingPurchaseDocumentResponse500 = {
  data: Error
  status: 500
}

export type createIncomingPurchaseDocumentResponseSuccess = (createIncomingPurchaseDocumentResponse201) & {
  headers: Headers;
};
export type createIncomingPurchaseDocumentResponseError = (createIncomingPurchaseDocumentResponse400 | createIncomingPurchaseDocumentResponse401 | createIncomingPurchaseDocumentResponse403 | createIncomingPurchaseDocumentResponse404 | createIncomingPurchaseDocumentResponse422 | createIncomingPurchaseDocumentResponse500) & {
  headers: Headers;
};

export type createIncomingPurchaseDocumentResponse = (createIncomingPurchaseDocumentResponseSuccess | createIncomingPurchaseDocumentResponseError)

export const getCreateIncomingPurchaseDocumentUrl = () => {


  

  return `/incoming-purchase-documents`
}

export const createIncomingPurchaseDocument = async (createIncomingPurchaseDocumentBody: CreateIncomingPurchaseDocumentBody, options?: RequestInit): Promise<createIncomingPurchaseDocumentResponse> => {
  
  return customFetch<createIncomingPurchaseDocumentResponse>(getCreateIncomingPurchaseDocumentUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createIncomingPurchaseDocumentBody,)
  }
);}
  

/**
 * Retrieve a paginated list of incoming purchase documents with optional filtering.
Supports cursor-based pagination, full-text search across supplier snapshot and document fields, and suite-standard JSON query filters for date, totals, payment state, and supplier snapshot data.
 * @summary List incoming purchase documents
 */
export type getIncomingPurchaseDocumentsResponse200 = {
  data: GetIncomingPurchaseDocuments200
  status: 200
}

export type getIncomingPurchaseDocumentsResponse400 = {
  data: Error
  status: 400
}

export type getIncomingPurchaseDocumentsResponse401 = {
  data: Error
  status: 401
}

export type getIncomingPurchaseDocumentsResponse403 = {
  data: Error
  status: 403
}

export type getIncomingPurchaseDocumentsResponse404 = {
  data: Error
  status: 404
}

export type getIncomingPurchaseDocumentsResponse500 = {
  data: Error
  status: 500
}

export type getIncomingPurchaseDocumentsResponseSuccess = (getIncomingPurchaseDocumentsResponse200) & {
  headers: Headers;
};
export type getIncomingPurchaseDocumentsResponseError = (getIncomingPurchaseDocumentsResponse400 | getIncomingPurchaseDocumentsResponse401 | getIncomingPurchaseDocumentsResponse403 | getIncomingPurchaseDocumentsResponse404 | getIncomingPurchaseDocumentsResponse500) & {
  headers: Headers;
};

export type getIncomingPurchaseDocumentsResponse = (getIncomingPurchaseDocumentsResponseSuccess | getIncomingPurchaseDocumentsResponseError)

export const getGetIncomingPurchaseDocumentsUrl = (params?: GetIncomingPurchaseDocumentsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/incoming-purchase-documents?${stringifiedParams}` : `/incoming-purchase-documents`
}

export const getIncomingPurchaseDocuments = async (params?: GetIncomingPurchaseDocumentsParams, options?: RequestInit): Promise<getIncomingPurchaseDocumentsResponse> => {
  
  return customFetch<getIncomingPurchaseDocumentsResponse>(getGetIncomingPurchaseDocumentsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Create an incoming purchase document using externally prepared values from OCR, ERP, or accounting software.
The caller provides document totals, item totals, and tax summaries directly.
The persistence, supplier handling, payment tracking initialization, and lifecycle rules are identical to the standard create endpoint.
 * @summary Create incoming purchase document with pre-calculated totals
 */
export type createCustomIncomingPurchaseDocumentResponse201 = {
  data: IncomingPurchaseDocument
  status: 201
}

export type createCustomIncomingPurchaseDocumentResponse400 = {
  data: Error
  status: 400
}

export type createCustomIncomingPurchaseDocumentResponse401 = {
  data: Error
  status: 401
}

export type createCustomIncomingPurchaseDocumentResponse403 = {
  data: Error
  status: 403
}

export type createCustomIncomingPurchaseDocumentResponse404 = {
  data: Error
  status: 404
}

export type createCustomIncomingPurchaseDocumentResponse422 = {
  data: ValidationError
  status: 422
}

export type createCustomIncomingPurchaseDocumentResponse500 = {
  data: Error
  status: 500
}

export type createCustomIncomingPurchaseDocumentResponseSuccess = (createCustomIncomingPurchaseDocumentResponse201) & {
  headers: Headers;
};
export type createCustomIncomingPurchaseDocumentResponseError = (createCustomIncomingPurchaseDocumentResponse400 | createCustomIncomingPurchaseDocumentResponse401 | createCustomIncomingPurchaseDocumentResponse403 | createCustomIncomingPurchaseDocumentResponse404 | createCustomIncomingPurchaseDocumentResponse422 | createCustomIncomingPurchaseDocumentResponse500) & {
  headers: Headers;
};

export type createCustomIncomingPurchaseDocumentResponse = (createCustomIncomingPurchaseDocumentResponseSuccess | createCustomIncomingPurchaseDocumentResponseError)

export const getCreateCustomIncomingPurchaseDocumentUrl = () => {


  

  return `/incoming-purchase-documents/custom`
}

export const createCustomIncomingPurchaseDocument = async (customCreateIncomingPurchaseDocument: CustomCreateIncomingPurchaseDocument, options?: RequestInit): Promise<createCustomIncomingPurchaseDocumentResponse> => {
  
  return customFetch<createCustomIncomingPurchaseDocumentResponse>(getCreateCustomIncomingPurchaseDocumentUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      customCreateIncomingPurchaseDocument,)
  }
);}
  

/**
 * @summary Get incoming purchase document by ID
 */
export type getIncomingPurchaseDocumentByIdResponse200 = {
  data: IncomingPurchaseDocument
  status: 200
}

export type getIncomingPurchaseDocumentByIdResponse401 = {
  data: Error
  status: 401
}

export type getIncomingPurchaseDocumentByIdResponse403 = {
  data: Error
  status: 403
}

export type getIncomingPurchaseDocumentByIdResponse404 = {
  data: Error
  status: 404
}

export type getIncomingPurchaseDocumentByIdResponse500 = {
  data: Error
  status: 500
}

export type getIncomingPurchaseDocumentByIdResponseSuccess = (getIncomingPurchaseDocumentByIdResponse200) & {
  headers: Headers;
};
export type getIncomingPurchaseDocumentByIdResponseError = (getIncomingPurchaseDocumentByIdResponse401 | getIncomingPurchaseDocumentByIdResponse403 | getIncomingPurchaseDocumentByIdResponse404 | getIncomingPurchaseDocumentByIdResponse500) & {
  headers: Headers;
};

export type getIncomingPurchaseDocumentByIdResponse = (getIncomingPurchaseDocumentByIdResponseSuccess | getIncomingPurchaseDocumentByIdResponseError)

export const getGetIncomingPurchaseDocumentByIdUrl = (id: string,) => {


  

  return `/incoming-purchase-documents/${id}`
}

export const getIncomingPurchaseDocumentById = async (id: string, options?: RequestInit): Promise<getIncomingPurchaseDocumentByIdResponse> => {
  
  return customFetch<getIncomingPurchaseDocumentByIdResponse>(getGetIncomingPurchaseDocumentByIdUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * @summary Update incoming purchase document
 */
export type updateIncomingPurchaseDocumentResponse200 = {
  data: IncomingPurchaseDocument
  status: 200
}

export type updateIncomingPurchaseDocumentResponse400 = {
  data: Error
  status: 400
}

export type updateIncomingPurchaseDocumentResponse401 = {
  data: Error
  status: 401
}

export type updateIncomingPurchaseDocumentResponse403 = {
  data: Error
  status: 403
}

export type updateIncomingPurchaseDocumentResponse404 = {
  data: Error
  status: 404
}

export type updateIncomingPurchaseDocumentResponse422 = {
  data: ValidationError
  status: 422
}

export type updateIncomingPurchaseDocumentResponse500 = {
  data: Error
  status: 500
}

export type updateIncomingPurchaseDocumentResponseSuccess = (updateIncomingPurchaseDocumentResponse200) & {
  headers: Headers;
};
export type updateIncomingPurchaseDocumentResponseError = (updateIncomingPurchaseDocumentResponse400 | updateIncomingPurchaseDocumentResponse401 | updateIncomingPurchaseDocumentResponse403 | updateIncomingPurchaseDocumentResponse404 | updateIncomingPurchaseDocumentResponse422 | updateIncomingPurchaseDocumentResponse500) & {
  headers: Headers;
};

export type updateIncomingPurchaseDocumentResponse = (updateIncomingPurchaseDocumentResponseSuccess | updateIncomingPurchaseDocumentResponseError)

export const getUpdateIncomingPurchaseDocumentUrl = (id: string,) => {


  

  return `/incoming-purchase-documents/${id}`
}

export const updateIncomingPurchaseDocument = async (id: string,
    updateIncomingPurchaseDocumentBody: UpdateIncomingPurchaseDocumentBody, options?: RequestInit): Promise<updateIncomingPurchaseDocumentResponse> => {
  
  return customFetch<updateIncomingPurchaseDocumentResponse>(getUpdateIncomingPurchaseDocumentUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateIncomingPurchaseDocumentBody,)
  }
);}
  

/**
 * @summary Upload incoming purchase document attachment
 */
export type uploadIncomingPurchaseDocumentAttachmentResponse201 = {
  data: FileMetadata
  status: 201
}

export type uploadIncomingPurchaseDocumentAttachmentResponse400 = {
  data: Error
  status: 400
}

export type uploadIncomingPurchaseDocumentAttachmentResponse401 = {
  data: Error
  status: 401
}

export type uploadIncomingPurchaseDocumentAttachmentResponse403 = {
  data: Error
  status: 403
}

export type uploadIncomingPurchaseDocumentAttachmentResponse404 = {
  data: Error
  status: 404
}

export type uploadIncomingPurchaseDocumentAttachmentResponse422 = {
  data: ValidationError
  status: 422
}

export type uploadIncomingPurchaseDocumentAttachmentResponse500 = {
  data: Error
  status: 500
}

export type uploadIncomingPurchaseDocumentAttachmentResponseSuccess = (uploadIncomingPurchaseDocumentAttachmentResponse201) & {
  headers: Headers;
};
export type uploadIncomingPurchaseDocumentAttachmentResponseError = (uploadIncomingPurchaseDocumentAttachmentResponse400 | uploadIncomingPurchaseDocumentAttachmentResponse401 | uploadIncomingPurchaseDocumentAttachmentResponse403 | uploadIncomingPurchaseDocumentAttachmentResponse404 | uploadIncomingPurchaseDocumentAttachmentResponse422 | uploadIncomingPurchaseDocumentAttachmentResponse500) & {
  headers: Headers;
};

export type uploadIncomingPurchaseDocumentAttachmentResponse = (uploadIncomingPurchaseDocumentAttachmentResponseSuccess | uploadIncomingPurchaseDocumentAttachmentResponseError)

export const getUploadIncomingPurchaseDocumentAttachmentUrl = (id: string,) => {


  

  return `/incoming-purchase-documents/${id}/attachments`
}

export const uploadIncomingPurchaseDocumentAttachment = async (id: string,
    uploadIncomingPurchaseDocumentAttachmentBody: UploadIncomingPurchaseDocumentAttachmentBody, options?: RequestInit): Promise<uploadIncomingPurchaseDocumentAttachmentResponse> => {
    const formData = new FormData();
if(uploadIncomingPurchaseDocumentAttachmentBody.file !== undefined) {
 formData.append(`file`, uploadIncomingPurchaseDocumentAttachmentBody.file);
 }

  return customFetch<uploadIncomingPurchaseDocumentAttachmentResponse>(getUploadIncomingPurchaseDocumentAttachmentUrl(id),
  {      
    ...options,
    method: 'POST'
    ,
    body: 
      formData,
  }
);}
  

/**
 * @summary List incoming purchase document attachments
 */
export type getIncomingPurchaseDocumentAttachmentsResponse200 = {
  data: GetIncomingPurchaseDocumentAttachments200
  status: 200
}

export type getIncomingPurchaseDocumentAttachmentsResponse401 = {
  data: Error
  status: 401
}

export type getIncomingPurchaseDocumentAttachmentsResponse403 = {
  data: Error
  status: 403
}

export type getIncomingPurchaseDocumentAttachmentsResponse404 = {
  data: Error
  status: 404
}

export type getIncomingPurchaseDocumentAttachmentsResponse500 = {
  data: Error
  status: 500
}

export type getIncomingPurchaseDocumentAttachmentsResponseSuccess = (getIncomingPurchaseDocumentAttachmentsResponse200) & {
  headers: Headers;
};
export type getIncomingPurchaseDocumentAttachmentsResponseError = (getIncomingPurchaseDocumentAttachmentsResponse401 | getIncomingPurchaseDocumentAttachmentsResponse403 | getIncomingPurchaseDocumentAttachmentsResponse404 | getIncomingPurchaseDocumentAttachmentsResponse500) & {
  headers: Headers;
};

export type getIncomingPurchaseDocumentAttachmentsResponse = (getIncomingPurchaseDocumentAttachmentsResponseSuccess | getIncomingPurchaseDocumentAttachmentsResponseError)

export const getGetIncomingPurchaseDocumentAttachmentsUrl = (id: string,) => {


  

  return `/incoming-purchase-documents/${id}/attachments`
}

export const getIncomingPurchaseDocumentAttachments = async (id: string, options?: RequestInit): Promise<getIncomingPurchaseDocumentAttachmentsResponse> => {
  
  return customFetch<getIncomingPurchaseDocumentAttachmentsResponse>(getGetIncomingPurchaseDocumentAttachmentsUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * @summary Delete incoming purchase document attachment
 */
export type deleteIncomingPurchaseDocumentAttachmentResponse204 = {
  data: void
  status: 204
}

export type deleteIncomingPurchaseDocumentAttachmentResponse401 = {
  data: Error
  status: 401
}

export type deleteIncomingPurchaseDocumentAttachmentResponse403 = {
  data: Error
  status: 403
}

export type deleteIncomingPurchaseDocumentAttachmentResponse404 = {
  data: Error
  status: 404
}

export type deleteIncomingPurchaseDocumentAttachmentResponse500 = {
  data: Error
  status: 500
}

export type deleteIncomingPurchaseDocumentAttachmentResponseSuccess = (deleteIncomingPurchaseDocumentAttachmentResponse204) & {
  headers: Headers;
};
export type deleteIncomingPurchaseDocumentAttachmentResponseError = (deleteIncomingPurchaseDocumentAttachmentResponse401 | deleteIncomingPurchaseDocumentAttachmentResponse403 | deleteIncomingPurchaseDocumentAttachmentResponse404 | deleteIncomingPurchaseDocumentAttachmentResponse500) & {
  headers: Headers;
};

export type deleteIncomingPurchaseDocumentAttachmentResponse = (deleteIncomingPurchaseDocumentAttachmentResponseSuccess | deleteIncomingPurchaseDocumentAttachmentResponseError)

export const getDeleteIncomingPurchaseDocumentAttachmentUrl = (id: string,
    fileId: string,) => {


  

  return `/incoming-purchase-documents/${id}/attachments/${fileId}`
}

export const deleteIncomingPurchaseDocumentAttachment = async (id: string,
    fileId: string, options?: RequestInit): Promise<deleteIncomingPurchaseDocumentAttachmentResponse> => {
  
  return customFetch<deleteIncomingPurchaseDocumentAttachmentResponse>(getDeleteIncomingPurchaseDocumentAttachmentUrl(id,fileId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}
  

/**
 * @summary List payments affecting an incoming purchase document
 */
export type getIncomingPurchaseDocumentPaymentsResponse200 = {
  data: GetIncomingPurchaseDocumentPayments200
  status: 200
}

export type getIncomingPurchaseDocumentPaymentsResponse401 = {
  data: Error
  status: 401
}

export type getIncomingPurchaseDocumentPaymentsResponse403 = {
  data: Error
  status: 403
}

export type getIncomingPurchaseDocumentPaymentsResponse404 = {
  data: Error
  status: 404
}

export type getIncomingPurchaseDocumentPaymentsResponse500 = {
  data: Error
  status: 500
}

export type getIncomingPurchaseDocumentPaymentsResponseSuccess = (getIncomingPurchaseDocumentPaymentsResponse200) & {
  headers: Headers;
};
export type getIncomingPurchaseDocumentPaymentsResponseError = (getIncomingPurchaseDocumentPaymentsResponse401 | getIncomingPurchaseDocumentPaymentsResponse403 | getIncomingPurchaseDocumentPaymentsResponse404 | getIncomingPurchaseDocumentPaymentsResponse500) & {
  headers: Headers;
};

export type getIncomingPurchaseDocumentPaymentsResponse = (getIncomingPurchaseDocumentPaymentsResponseSuccess | getIncomingPurchaseDocumentPaymentsResponseError)

export const getGetIncomingPurchaseDocumentPaymentsUrl = (id: string,) => {


  

  return `/incoming-purchase-documents/${id}/payments`
}

export const getIncomingPurchaseDocumentPayments = async (id: string, options?: RequestInit): Promise<getIncomingPurchaseDocumentPaymentsResponse> => {
  
  return customFetch<getIncomingPurchaseDocumentPaymentsResponse>(getGetIncomingPurchaseDocumentPaymentsUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * @summary Create a payment for an incoming purchase document
 */
export type createIncomingPurchaseDocumentPaymentResponse201 = {
  data: Payment
  status: 201
}

export type createIncomingPurchaseDocumentPaymentResponse400 = {
  data: Error
  status: 400
}

export type createIncomingPurchaseDocumentPaymentResponse401 = {
  data: Error
  status: 401
}

export type createIncomingPurchaseDocumentPaymentResponse403 = {
  data: Error
  status: 403
}

export type createIncomingPurchaseDocumentPaymentResponse404 = {
  data: Error
  status: 404
}

export type createIncomingPurchaseDocumentPaymentResponse422 = {
  data: ValidationError
  status: 422
}

export type createIncomingPurchaseDocumentPaymentResponse500 = {
  data: Error
  status: 500
}

export type createIncomingPurchaseDocumentPaymentResponseSuccess = (createIncomingPurchaseDocumentPaymentResponse201) & {
  headers: Headers;
};
export type createIncomingPurchaseDocumentPaymentResponseError = (createIncomingPurchaseDocumentPaymentResponse400 | createIncomingPurchaseDocumentPaymentResponse401 | createIncomingPurchaseDocumentPaymentResponse403 | createIncomingPurchaseDocumentPaymentResponse404 | createIncomingPurchaseDocumentPaymentResponse422 | createIncomingPurchaseDocumentPaymentResponse500) & {
  headers: Headers;
};

export type createIncomingPurchaseDocumentPaymentResponse = (createIncomingPurchaseDocumentPaymentResponseSuccess | createIncomingPurchaseDocumentPaymentResponseError)

export const getCreateIncomingPurchaseDocumentPaymentUrl = (id: string,) => {


  

  return `/incoming-purchase-documents/${id}/payments`
}

export const createIncomingPurchaseDocumentPayment = async (id: string,
    createIncomingPurchaseDocumentPaymentBody: CreateIncomingPurchaseDocumentPaymentBody, options?: RequestInit): Promise<createIncomingPurchaseDocumentPaymentResponse> => {
  
  return customFetch<createIncomingPurchaseDocumentPaymentResponse>(getCreateIncomingPurchaseDocumentPaymentUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createIncomingPurchaseDocumentPaymentBody,)
  }
);}
  

